export default "/images/AndreasZett.jpg?c0d5419fbac45a83bb7a0c6269821b74";